import { render, staticRenderFns } from "./ChatFormComponent.vue?vue&type=template&id=1c1de189&"
import script from "./ChatFormComponent.vue?vue&type=script&lang=js&"
export * from "./ChatFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports